import { Injectable } from '@angular/core';
import { ListDataColumnsI } from './table.interface';

@Injectable({
  providedIn: 'root',
})
export class ColumnConfigService {
  private readonly storageKey = 'columnConfig';

  // Obtener la configuración de columnas para una pantalla específica
  getConfig(screenId: string): ListDataColumnsI[] {
    const configs = JSON.parse(localStorage.getItem(this.storageKey) || '{}');
    return configs[screenId] || [];
  }

  // Guardar la configuración de columnas para una pantalla específica
  saveConfig(screenId: string, columns: ListDataColumnsI[]): void {
    const configs = JSON.parse(localStorage.getItem(this.storageKey) || '{}');
    configs[screenId] = columns;
    localStorage.setItem(this.storageKey, JSON.stringify(configs));
  }
}
